import { useEffect } from "react";
import type { MouseEvent } from "react";

export function useDirtyFormProtection(isDirty: boolean) {
  useEffect(() => {
    if (!isDirty) return;
    const preventUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", preventUnload);
    return () => window.removeEventListener("beforeunload", preventUnload);
  }, [isDirty]);

  return (event: MouseEvent<HTMLAnchorElement>) => {
    if (isDirty && !window.confirm("Há alterações não salvas. Deseja sair mesmo assim?")) {
      event.preventDefault();
    }
  };
}
